import { useSiteLogo, useSiteName } from "@/app/lib/features/settings/settings.hook";

const DEFAULT_LOGO = "/images/tozlu.png";
const DEFAULT_ALT = "Tozlu.com";

const useFallbackImage = () => {
  // Alan bazlı seçici: settings slice'ının başka alanları değiştiğinde bu hook'u
  // kullanan bileşenler (sayfada ~456 FallbackImage) yeniden render olmaz.
  // Primitif döndüğü için useMemo'ya da gerek yok.
  const siteLogo = useSiteLogo();
  const siteName = useSiteName();

  return {
    fallbackLogo: siteLogo || DEFAULT_LOGO,
    fallbackAlt: siteName || DEFAULT_ALT,
    DEFAULT_LOGO,
  };
};

export default useFallbackImage;
